import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';

var IconLoading = /*#__PURE__*/function (_React$Component) {
  _inherits(IconLoading, _React$Component);

  var _super = _createSuper(IconLoading);

  function IconLoading(props) {
    _classCallCheck(this, IconLoading);

    return _super.call(this, props);
  }

  _createClass(IconLoading, [{
    key: "render",
    value: function render() {
      var isServerRendering = function () {
        try {
          return !((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && document !== undefined);
        } catch (e) {
          return true;
        }
      }();

      var prefixCls = !isServerRendering && window.BYTEUI_PREFIXCLS ? window.BYTEUI_PREFIXCLS : this.props.prefixCls;
      var className = this.props && this.props.className ? this.props.className + ' ' : '';

      var props = _objectSpread({}, this.props, {
        className: className + 'byte-icon byte-icon-loading'.replace(/byte-/g, prefixCls + '-')
      });

      if (this.props.spin) {
        props.className = props.className + ' ' + prefixCls + '-icon-loading';
      }

      delete props.prefixCls;
      delete props.spin;
      delete props.isIcon;
      return /*#__PURE__*/React.createElement("svg", _extends({
        className: "byte-icon byte-icon-loading",
        viewBox: "0 0 1024 1024",
        width: "1em",
        height: "1em",
        fill: "currentColor"
      }, props), /*#__PURE__*/React.createElement("path", {
        d: "M980.752 313.697c-25.789-60.972-62.702-115.725-109.713-162.736-47.012-47.011-101.764-83.924-162.736-109.713C645.161 14.542 578.106 1 509 1c-2.242 0-4.48.015-6.715.043-16.567.211-29.826 13.812-29.615 30.38.209 16.438 13.599 29.618 29.99 29.618l.39-.002c1.98-.026 3.963-.039 5.95-.039 61.033 0 120.224 11.947 175.93 35.508 53.82 22.764 102.162 55.359 143.683 96.879s74.115 89.862 96.88 143.683C949.054 392.776 961 451.967 961 513c0 16.568 13.432 30 30 30s30-13.432 30-30c0-69.106-13.541-136.162-40.248-199.303z"
      }));
    }
  }]);

  return IconLoading;
}(React.Component);

IconLoading.defaultProps = {
  isIcon: true,
  prefixCls: 'byte'
};
export default IconLoading;